import React, { useEffect } from "react";
import Div from "@jumbo/shared/Div";
import * as yup from "yup";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Select from "@mui/material/Select";
import {
  countryFormattingRules,
  PHONE_COUNTRIES,
} from "../../../../utils/constants/appActions";
import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";

const steps = [
  "Select campaign settings",
  "Create an ad group",
  "Create an ad",
];
const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string("Enter your password").required("Password is required"),
});

const Step1 = ({ setStepsData, hide, stepsData, handleNext }) => {
  const [values, setValues] = React.useState({
    email: "",
    firstName: "",
    lastName: "",
    title: "",
    dateOfBirth: "",
    knownUs: "",
    comments: "",
  });
  const [errMsg, setErrMsg] = React.useState("");
  const [errTitle, setErrTitle] = React.useState(false);
  const [errFirstName, setErrFirstName] = React.useState(false);
  const [errLastName, setErrLastName] = React.useState(false);
  const [errPhone, setErrPhone] = React.useState(false);
  const [errDateOfBirth, setDateofBirth] = React.useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    if (stepsData) {
      console.log("ParentData------", stepsData);
      console.log(stepsData.phone);
      const val = PHONE_COUNTRIES.find(
        (item) => item.code === stepsData.phone?.code,
      );
      stepsData.phone.label = val?.label;
      stepsData.phone.countryCode = val?.countryCode;
      setValues({ ...values, ...stepsData });

      if (stepsData.phone2) {
        const val2 = PHONE_COUNTRIES.find(
          (item) => item.code === stepsData?.phone2?.code,
        );
        stepsData.phone2.label = val2?.label;
        stepsData.phone2.countryCode = val2?.countryCode;
        setValues({ ...values, ...stepsData });
      }

      console.log("values-----", values);
    }
  }, [stepsData]);

  const handleChange = (prop) => (event) => {
    console.log([prop], event.target.value);
    setValues({ ...values, [prop]: event.target.value });
    console.log("--", values.title, "--");
  };

  const submitStep1 = async () => {
    setErrMsg("");

    const { firstName, lastName, title, phone, phone2 } = values;

    // Validate required fields
    if (!firstName || !lastName || !title || !phone?.number || !phone?.code) {
      setErrMsg(t("errMsg.notFill"));
      setTimeout(() => setErrMsg(""), 3000);
      return;
    }

    // Declare variables upfront
    let fullNumber, phone2Obj;

    // Validate primary phone
    fullNumber = `+${phone.code}${phone.number}`.replace(/\s/g, "");
    const fullNumberRegex =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;

    if (!fullNumberRegex.test(fullNumber)) {
      setErrMsg(t("errMsg.invalidPhone"));
      setTimeout(() => setErrMsg(""), 3000);
      return;
    }

    // Prepare phone2 only if it exists
    if (phone2?.number && phone2?.code) {
      const fullPhoneNumber2 = `+${phone2.code}${phone2.number}`.replace(
        /\s/g,
        "",
      );
      const fullNumberRegex2 =
        /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;

      if (!fullNumberRegex2.test(fullPhoneNumber2)) {
        setErrMsg(t("errMsg.invalidPhone"));
        setTimeout(() => setErrMsg(""), 3000);
        return;
      }

      phone2Obj = {
        fullNumber: fullPhoneNumber2,
        code: phone2.code,
        number: phone2.number,
      };
    }

    // Build submission object
    const obj = {
      ...values,
      phone: {
        fullNumber,
        code: phone.code,
        number: phone.number,
      },
      phone2: phone2Obj, // undefined if not provided
    };

    console.log("Step2------------", obj);

    setStepsData({ ...stepsData, ...obj });
    handleNext(2);
  };

  const submitStep11 = async () => {
    setErrMsg("");

    console.log(values);

    const { firstName, lastName, dateOfBirth, title, phone, phone2 } = values;
    const fullPhoneNumber = `+${phone.code}${phone.number}`;
    console.log("fullPhoneNumber", fullPhoneNumber);
    const fullNumberRegex =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;
    const fullPhoneNumberWithoutSpaces = fullPhoneNumber.replace(/\s/g, "");

    const fullPhoneNumber2 = `+${phone2.code}${phone2.number}`;
    console.log("fullPhoneNumber2", fullPhoneNumber2);
    const fullNumberRegex2 =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;
    const fullPhoneNumberWithoutSpaces2 = fullPhoneNumber2.replace(/\s/g, "");

    if (firstName && lastName && title && phone && phone.number && phone.code) {
      if (!fullNumberRegex.test(fullPhoneNumberWithoutSpaces)) {
        setErrMsg(t("errMsg.invalidPhone"));
        setTimeout(() => {
          setErrMsg("");
        }, 3000);
        return;
      }

      const validatedFullPhoneNumber = fullPhoneNumberWithoutSpaces;
      const obj = {
        ...values,
        phone: {
          fullNumber: fullPhoneNumberWithoutSpaces,
          code: values.phone.code,
          number: values.phone.number,
        },
        phone2: {
          fullNumber: fullPhoneNumberWithoutSpaces2,
          code: values.phone2.code,
          number: values.phone2.number,
        },
      };
      console.log("Step2------------", obj);

      setStepsData({ ...stepsData, ...obj });
      handleNext(2);
    } else {
      setErrMsg(t("errMsg.notFill"));
      setTimeout(() => {
        setErrMsg("");
      }, 3000);
    }
  };

  const handleCountryChange = (event, newValue) => {
    console.log(newValue);
    setValues({ ...values, phone: newValue });
  };

  const handleCountryChange2 = (event, newValue) => {
    console.log("phone2NewValue--------", newValue);
    setValues({ ...values, phone2: newValue });
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { mt: 5 },
      }}
      noValidate
      autoComplete="off"
    >
      <Div>
        <Div sx={{ minWidth: 120 }}>
          <FormControl
            sx={{
              mt: 4,
              //ml: 1,
              width: "21%",
            }}
          >
            <InputLabel error={errTitle} id="demo-simple-select-label">
              {t("parent.title.profileStepTitle")}
            </InputLabel>
            <Select
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={values.title}
              onChange={handleChange("title")}
              label={t("parent.title.profileStepTitle")}
              error={errTitle}
            >
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="Mr">{t("common.mr")}</MenuItem>
              <MenuItem value="Mrs">{t("common.mrs")}</MenuItem>
            </Select>
          </FormControl>
        </Div>
        <Div
          sx={{
            mt: -2,
          }}
        >
          <FormControl
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              disabled={true}
              error={errFirstName}
              label={t("common.email")}
              value={values.email}
            />
          </FormControl>

          <FormControl
            sx={{
              width: 500,
              maxWidth: "100%",
              mt: -2,
            }}
          >
            <TextField
              required
              error={errFirstName}
              label={t("common.firstName")}
              value={values.firstName}
              onChange={handleChange("firstName")}
            />
          </FormControl>

          <FormControl
            sx={{
              width: 500,
              maxWidth: "100%",
              mt: -2,
            }}
          >
            <TextField
              required
              error={errLastName}
              label={t("common.lastName")}
              value={values.lastName}
              onChange={handleChange("lastName")}
            />
          </FormControl>
          {/*<FormControl sx={{
                        width: {xs: '100%', sm: '100%', xl: '42%'},

                    }}>

                        <TextField
                            id="date"
                            error={errDateOfBirth}
                            label={(t('parent-children.title.dateBirth'))}
                            type="date"
                            value={values.dateOfBirth}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleChange('dateOfBirth')}
                        />
                    </FormControl>*/}
        </Div>
        <Div sx={{ mt: -1, mb: 2, display: "flex", alignItems: "center" }}>
          <FormControl
            variant="outlined"
            sx={{ flex: "0 0 130px", marginRight: 2 }}
          >
            {values.phone?.code && (
              <Autocomplete
                defaultValue={values.phone}
                options={PHONE_COUNTRIES}
                autoHighlight
                onChange={handleCountryChange}
                getOptionLabel={(option) => {
                  return " +" + option.code;
                }}
                disableClearable={true}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      src={`https://flagcdn.com/w20/${option.countryCode?.toLowerCase()}.png`}
                      srcSet={`https://flagcdn.com/w40/${option.countryCode?.toLowerCase()}.png 2x`}
                      alt=""
                    />
                    {option.countryCode}(+{option.code})
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={"Code"}
                    error={errPhone}
                    required
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <React.Fragment>
                          {values.phone && values.phone.countryCode && (
                            <img
                              loading="lazy"
                              width="20"
                              src={`https://flagcdn.com/w20/${values.phone.countryCode?.toLowerCase()}.png`}
                              srcSet={`https://flagcdn.com/w40/${values.phone.countryCode?.toLowerCase()}.png 2x`}
                              alt=""
                            />
                          )}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            )}
          </FormControl>

          <FormControl variant="outlined" sx={{ flex: 1 }}>
            <TextField
              required
              id="phone"
              label={t("common.phone")}
              error={errPhone}
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={values.phone?.number}
              onChange={(event) => {
                let inputNumber = event.target.value;

                // Remove leading zeros
                const sanitizedNumber = inputNumber
                  .replace(/\D/g, "")
                  .replace(/^0+/, "");

                let phone = values.phone;
                phone.number = sanitizedNumber;

                // Get selected country code
                const selectedCountryCode = phone.code;

                // Find the formatting rule for the selected country code
                const countryFormattingRule = countryFormattingRules.find(
                  (rule) => rule.code === selectedCountryCode,
                );

                // Enforce maximum digits restriction based on country code
                if (countryFormattingRule) {
                  const maxDigits = countryFormattingRule.maxDigits;

                  // If the input length exceeds the maximum allowed digits, truncate the input
                  if (phone.number.length > maxDigits) {
                    phone.number = phone.number.slice(0, maxDigits);
                  }

                  // If the input length equals the maximum allowed digits, prevent further input
                  if (phone.number.length === maxDigits) {
                    event.preventDefault();
                  }
                }

                setValues({ ...values, phone });
              }}
            />
          </FormControl>
        </Div>

        <Div sx={{ mt: -3, mb: 2, display: "flex", alignItems: "center" }}>
          <FormControl
            variant="outlined"
            sx={{ flex: "0 0 130px", marginRight: 2 }}
          >
            <Autocomplete
              //defaultValue={values.phone2}
              value={
                values.phone2 || {
                  code: "",
                  number: "",
                  countryCode: "",
                  label: "",
                }
              }
              options={PHONE_COUNTRIES}
              autoHighlight
              onChange={handleCountryChange2}
              getOptionLabel={(option) => {
                return " +" + option.code;
              }}
              disableClearable={true}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  <img
                    loading="lazy"
                    width="20"
                    src={`https://flagcdn.com/w20/${option.countryCode?.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${option.countryCode?.toLowerCase()}.png 2x`}
                    alt=""
                  />
                  {option.countryCode}(+{option.code})
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Code"}
                  error={errPhone}
                  required
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <React.Fragment>
                        {values.phone2 && values.phone2.countryCode && (
                          <img
                            loading="lazy"
                            width="20"
                            src={`https://flagcdn.com/w20/${values.phone2.countryCode?.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${values.phone2.countryCode?.toLowerCase()}.png 2x`}
                            alt=""
                          />
                        )}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </FormControl>

          <FormControl variant="outlined" sx={{ flex: 1 }}>
            <TextField
              required
              id="phone"
              label={t("common.phone2")}
              error={errPhone}
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={values.phone2?.number || ""}
              onChange={(event) => {
                let inputNumber2 = event.target.value;

                // Remove leading zeros
                const sanitizedNumber2 = inputNumber2
                  .replace(/\D/g, "")
                  .replace(/^0+/, "");

                let phone2 = values.phone2;
                phone2.number = sanitizedNumber2;

                // Get selected country code
                const selectedCountryCode2 = phone2.code;

                // Find the formatting rule for the selected country code
                const countryFormattingRule2 = countryFormattingRules.find(
                  (rule) => rule.code === selectedCountryCode2,
                );

                // Enforce maximum digits restriction based on country code
                if (countryFormattingRule2) {
                  const maxDigits = countryFormattingRule2.maxDigits;

                  // If the input length exceeds the maximum allowed digits, truncate the input
                  if (phone2.number.length > maxDigits) {
                    phone2.number = phone2.number.slice(0, maxDigits);
                  }

                  // If the input length equals the maximum allowed digits, prevent further input
                  if (phone2.number.length === maxDigits) {
                    event.preventDefault();
                  }
                }

                setValues({ ...values, phone2 });
              }}
            />
          </FormControl>
        </Div>

        <FormControl
          sx={{
            width: 500,
            maxWidth: "100%",
            mt: 1,
          }}
        >
          <InputLabel id="demo-simple-select-label">
            {t("common.knowUs")}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={values.knownUs}
            onChange={handleChange("knownUs")}
            label={t("common.knowUs")}
          >
            <MenuItem value="">{t("parent.title.select")}</MenuItem>
            <MenuItem value="Recherche internet">
              {t("listItem.item1")}
            </MenuItem>
            <MenuItem value="Bouche à oreille">{t("listItem.item2")}</MenuItem>
            <MenuItem value="Instagram">{t("listItem.item3")}</MenuItem>
            <MenuItem value="Facebook">{t("listItem.item4")}</MenuItem>
            <MenuItem value="YouTube">{t("listItem.item5")}</MenuItem>
            <MenuItem value="CSE">{t("listItem.item6")}</MenuItem>
            <MenuItem value="Association">{t("listItem.item7")}</MenuItem>
            <MenuItem value="Salon d’exposition">
              {t("listItem.item8")}
            </MenuItem>
            <MenuItem value="Ecole privée">{t("listItem.item9")}</MenuItem>
            <MenuItem value="Medias (télé, journaux, radio...)">
              {t("listItem.item10")}
            </MenuItem>
            <MenuItem value="Autre">{t("listItem.item11")}</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          sx={{
            width: 500,
            maxWidth: "100%",
            mt: -2,
          }}
        >
          <TextField
            id="outlined-multiline-static"
            label={t("common.comment")}
            multiline
            rows={1}
            value={values.comments}
            name="comments"
            onChange={handleChange("comments")}
          />
        </FormControl>
      </Div>

      <Stack sx={{ width: "100%" }} spacing={2}>
        {errMsg && <Alert severity="error">{errMsg}</Alert>}
      </Stack>
      <Div sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        {/*<Button
                    onClick={() => {
                        hide();
                    }}
                    sx={{mr: 1}}
                >
                    {t("common.closeBtn")}
                </Button>*/}

        <Div sx={{ flex: "1 1 auto" }} />

        <LoadingButton
          variant={"variant"}
          onClick={submitStep1}
          sx={{
            backgroundColor: "#2d6bbf", // standard MUI red
            color: "#fff",
            "&:hover": {
              bgcolor: "#265ca6", // darker red on hover
            },
          }}
        >
          {t("common.nextBtn")}
        </LoadingButton>
      </Div>
    </Box>
  );
};

export default Step1;
